<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
@if(accessLoader){
<div class="loader text-center">
	<img src="../assets/img/cc_loader.gif" />
</div>
}
@if(UserModuleAccess=='Full' && user_type=='cdm'){
<div class="card">
	<div class="card-body">
		<h2 class="card-title">
			{{pagetitle}}
			<a class="btn btn-sm btn-outline-success float-end" [routerLink]="['/app/create-company']">
				<fa-icon [icon]="['fas', 'plus']"></fa-icon>
				Create Company
			</a>
		</h2>
		<div class="row">
			<div class="col-md-12">
				<div class="table-responsive">
					<table datatable [dtOptions]="dtOptions"
						class="table table-striped table-bordered table-hover comp-table" style="width: 100%;">
						<thead>
							<tr class="table_head">
								<th style="width: 20% !important;">Company</th>
								<th style="width: 15% !important;">Email</th>
								<th style="width: 10% !important;">Contact</th>
								<th style="width: 5% !important;" class="text-center">SC</th>
								<th style="width: 5% !important;" class="text-center">HC</th>
								<th style="width: 15% !important;">MHS</th>
								<th style="width: 5% !important;" class="text-center">CLIP</th>
								<th style="width: 5% !important;" class="text-center">Pharma</th>
								<th style="width: 5% !important;" class="text-center">Training</th>
								<th style="width: 5% !important;" class="text-center">Simulation</th>
								<th style="width: 10% !important;">Action</th>
							</tr>
						</thead>
						@if(dataList?.length){
						<tbody>
							<tr *ngFor="let v of dataList;let i = index;">
								<td>{{ v.name }}</td>
								<td>
									<span matTooltip="{{v.email}}">
										{{ v.email | limitTo:'20' }}
									</span>
								</td>
								<td>{{ v.phone_no }}</td>
								<td class="text-center">
									@if(v.clip_id){
									<button class="btn btn-xs btn-outline-danger" matTooltip="Delete from Shore Care"
										id="btnDeleteSC{{v.id1}}" (click)="deleteConfirmSC(v.id1,i)">
										@if (showDeleteLoaderSC == i) {
										<fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
										}@else {
										<fa-icon [icon]="['fas', 'times']"></fa-icon>
										}
									</button>
									}@else {
									<button class="btn btn-xs btn-outline-success" matTooltip="Create in Shore Care"
										id="btnCreateSC{{v.id1}}" (click)="createConfirmSC(v.id1,i)">
										@if (showCreateLoaderSC == i) {
										<fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
										}@else{
										<fa-icon [icon]="['fas', 'building']"></fa-icon>
										}
									</button>
									}
								</td>
								<td class="text-center">
									@if (v.hc_id) {
									<button class="btn btn-xs btn-outline-danger" matTooltip="Delete from HC"
										id="btnDeleteHC{{v.id1}}" (click)="deleteConfirmHC(v.id1,i)">
										@if (showDeleteLoaderHC == i) {
										<fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
										}@else {
										<fa-icon [icon]="['fas', 'times']"></fa-icon>
										}
									</button>
									}@else {
									<button class="btn btn-xs btn-outline-success" matTooltip="Create in HC"
										id="btnCreateHC{{v.id1}}" (click)="createConfirmHC(v.id1,i)">
										@if (showCreateLoaderHC == i) {
										<fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
										}@else {
										<fa-icon [icon]="['fas', 'building']"></fa-icon>
										}
									</button>
									}
								</td>
								<td>
									@if (v.mhs_id) {
									<button class="btn btn-xs btn-outline-danger" matTooltip="Delete from MHS"
										id="btnDeleteMHS{{v.id1}}" (click)="deleteConfirmMHS(v.id1,i)">
										@if (showDeleteLoaderMHS == i) {
										<fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
										}@else {
										<fa-icon [icon]="['fas', 'times']"></fa-icon>
										}
									</button>
									@if (v.mhs_com_user) {
									<button class="btn btn-xs btn-outline-success ms-1"
										matTooltip="Reset password in MHS" (click)="resetConfirmMHSUser(v.id,i)">
										@if (showLoaderMHSUserReset == i) {
										<fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
										}@else {
										<fa-icon [icon]="['fas', 'user-lock']"></fa-icon>
										}
									</button>
									<button class="btn btn-xs btn-outline-danger ms-1" matTooltip="Delete user from MHS"
										(click)="deleteConfirmMHSUser(v.id,i)">
										@if (showDeleteLoaderMHSUser == i) {
										<fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
										}@else {
										<fa-icon [icon]="['fas', 'user-times']"></fa-icon>
										}
									</button>
									}@else {
									<button class="btn btn-xs btn-outline-success ms-1" matTooltip="Create user in MHS"
										(click)="createConfirmMHSUser(v.id,i)">
										@if (showCreateLoaderMHSUser == i) {
										<fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
										}@else {
										<fa-icon [icon]="['fas', 'user-plus']"></fa-icon>
										}
									</button>
									}
									}@else {
									<button class="btn btn-xs btn-outline-success" matTooltip="Create in MHS"
										id="btnCreateMHS{{v.id1}}" (click)="createConfirmMHS(v.id1,i)">
										@if (showCreateLoaderMHS == i){
										<fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
										}@else {
										<fa-icon [icon]="['fas', 'building']"></fa-icon>
										}
									</button>
									}
								</td>
								<td class="text-center">
									@if (v.clip_main_company) {
									<button class="btn btn-xs btn-outline-danger" matTooltip="Delete from CLIP"
										id="btnDeleteCLIP{{v.id1}}" (click)="deleteConfirmCLIP(v.id1,i)">
										@if (showDeleteLoaderCLIP == i) {
										<fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
										}@else {
										<fa-icon [icon]="['fas', 'times']"></fa-icon>
										}
									</button>
									}@else {
									<button class="btn btn-xs btn-outline-success" matTooltip="Create in CLIP"
										id="btnCreateCLIP{{v.id1}}" (click)="createConfirmCLIP(v.id1,i)">
										@if (showCreateLoaderCLIP == v.id1){
										<fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
										}@else {
										<fa-icon [icon]="['fas', 'building']"></fa-icon>
										}
									</button>
									}
								</td>
								<td class="text-center">
									@if (v.pharma_id) {
									<button class="btn btn-xs btn-outline-danger" matTooltip="Delete from Pharma"
										id="btnDeletePharma{{v.id1}}" (click)="deleteConfirmPharma(v.id1,i)">
										@if (showDeleteLoaderPharma == i) {
										<fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
										}@else {
										<fa-icon [icon]="['fas', 'times']"></fa-icon>
										}
									</button>
									}@else {
									<button class="btn btn-xs btn-outline-success" matTooltip="Create in Pharma"
										id="btnCreatePharma{{v.id1}}" (click)="createConfirmPharma(v.id1,i)">
										@if (showCreateLoaderPharma == i) {
										<fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
										}@else {
										<fa-icon [icon]="['fas', 'building']"></fa-icon>
										}
									</button>
									}
								</td>
								<td class="text-center">
									@if (v.training_id) {
									<button class="btn btn-xs btn-outline-danger" matTooltip="Delete from Training"
										id="btnDeleteTraining{{v.id1}}" (click)="deleteConfirmTraining(v.id1,i)">
										@if (showDeleteLoaderTraining == i) {
										<fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
										}@else {
										<fa-icon [icon]="['fas', 'times']"></fa-icon>
										}
									</button>
									}@else {
									<button class="btn btn-xs btn-outline-success" matTooltip="Create in Training"
										id="btnCreateTraining{{v.id1}}" (click)="createConfirmTraining(v.id1,i)">
										@if (showCreateLoaderTraining == i) {
										<fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
										}@else {
										<fa-icon [icon]="['fas', 'building']"></fa-icon>
										}
									</button>
									}
								</td>
								<td class="text-center">
									@if (v.simulation_id) {
									<button class="btn btn-xs btn-outline-danger" matTooltip="Delete from Simulation"
										id="btnDeleteSimulation{{v.id1}}" (click)="deleteConfirmSimulation(v.id1,i)">
										@if (showDeleteLoaderSimulation == i) {
										<fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
										}@else {
										<fa-icon [icon]="['fas', 'times']"></fa-icon>
										}
									</button>
									}@else {
									<button class="btn btn-xs btn-outline-success" matTooltip="Create in Simulation"
										id="btnCreateSimulation{{v.id1}}" (click)="createConfirmSimulation(v.id1,i)">
										@if (showCreateLoaderSimulation == i) {
										<fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
										}@else {
										<fa-icon [icon]="['fas', 'building']"></fa-icon>
										}
									</button>
									}
								</td>
								<td>
									<a class="btn btn-xs btn-outline-primary" matTooltip="Edit"
										[routerLink]="['/app/edit-company',v.id1]">
										<fa-icon [icon]="['fas', 'pencil-alt']"></fa-icon>
									</a>
									<button class="btn btn-xs btn-outline-danger ms-1" matTooltip="Delete"
										(click)="deleteConfirm(v.id1,i)">
										@if (showDeleteLoader == i) {
										<fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
										}@else {
										<fa-icon [icon]="['fas', 'times']"></fa-icon>
										}
									</button>
									<a class="btn btn-xs btn-outline-info ms-1" matTooltip="Send mail to vessels"
										[routerLink]="['/app/send-mail',v.id1]">
										<fa-icon [icon]="['fas', 'envelope']"></fa-icon>
									</a>
									@if (v.message_id) {
									<a class="btn btn-xs btn-outline-warning ms-1" matTooltip="Mail status"
										[routerLink]="['/app/mail-status',v.id1]">
										<fa-icon [icon]="['fas', 'envelope-open-text']"></fa-icon>
									</a>
									}
								</td>
							</tr>
						</tbody>
						}@else {
						<tbody>
							<tr>
								<td colspan="11" class="text-center">No data found!</td>
							</tr>
						</tbody>
						}
					</table>
				</div>
			</div>
		</div>
	</div>
</div>
}@else {
<div>
	<h3 class="text-center">You don't have access to this section.</h3>
</div>
}